import {fetch, normalize} from "utils/dataAccess";
import {getMemberRetailers} from "../../actions/authentificationMember";
import {sessionStore} from "../../utils/sessionStore";

export default async function update(user, values) {
    const response = await fetch(user['@id'], {
        method: "PUT",
        headers: new Headers({"Content-Type": "application/ld+json"}),
        body: JSON.stringify(values)
    });

    if (!response.ok) throw new Error('Failed to update user');

    let retrieved = await response.json();

    retrieved = normalize(retrieved);

    let member = sessionStore.get("member");

    member["email"] = retrieved["email"];
    member["familyName"] = retrieved["familyName"];
    member["givenName"] = retrieved["givenName"];
    member["organization"] = retrieved["currentOrganization"].replace('/organizations/', '');
    member.retailers = getMemberRetailers();

    sessionStore.set("member", member);

    return retrieved;
}

export async function changeCurrentOrganization(userId, newOrganizationId, targetPath = null) {
    if (!userId || !newOrganizationId) {
        return;
    }

    const values = {
        'currentOrganization': `/organizations/${newOrganizationId}`
    };

    const user = {
        '@id': `/users/${userId}`
    };

    await update(user, values).then(() => {
        // Grab the new org's subdomain before clearing localStorage
        const organizations = JSON.parse(localStorage.getItem('_mp_organizations') || '{}')?.value;
        const newOrg = organizations ? organizations[newOrganizationId] : null;

        sessionStore.clear();

        if (newOrg && newOrg.subdomain) {
            // Redirect directly to the correct subdomain to avoid a wasted /login_sync
            let redirectUrl = window.location.protocol + "//" + newOrg.subdomain + "." + process.env.REACT_APP_HOST;
            const portParts = window.location.host.split(":");
            if (portParts.length === 2) {
                redirectUrl += ":" + portParts[1];
            }
            window.location = redirectUrl + (targetPath ?? "");
        } else {
            window.location = targetPath ?? "/";
        }
    });
}
